<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <div id="novel_main">
                <ScriptChapter ref="scriptChapter" />
            </div>

        </div>
    </div>
</template>

<script>
import SApi from '@/api/script'
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import ScriptChapter from '@/components/script/script_chapter.vue' //章节管理
import { EncryptionUtil } from '@/utils/encrypt'
export default {
    components: {
        top, left, ScriptChapter
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
        }
    },
    created() {
        let pageNum = this.$route.query?.pageNum || 1
        let novelInfo = this.$route.query?.novelInfo ? EncryptionUtil.decrypt(this.$route.query.novelInfo) : {}
        let isShowZG = this.$route.query?.isShowZG
        if (novelInfo.id) {
            this.$nextTick(() => {
                if (this.$refs.scriptChapter) {
                    console.log('执行章节列表接口')
                    this.$refs.scriptChapter.getChapterList(novelInfo)
                }
            })
        }
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        toNovellist() {
            this.$router.replace({ path: '/novel', query: {} })
        }
    }
}
</script>

<style>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    min-width: 1500px;
}
</style>